import { Injectable } from '@angular/core';
import { Unit } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util';

@Injectable({ providedIn: 'root' })
export class UnitNormalizer implements Converter<Occ.Unit, Unit> {
  convert(source: Occ.Unit, target?: Unit): Unit {
    if (source) {
      target = this.convertUnit(source);
    }

    return target;
  }

  private convertUnit(source: Occ.Unit): Unit {
    if (source) {
      const { isoCode, ...target } = source;
      return {
        ...target,
        isocode: isoCode,
      };
    } else {
      return undefined;
    }
  }
}
